<template>
    <div id="auth" class="container">
        <section id="auth-content" class="box padding w-buttons install">
            <h2>Remova seu contato da lista</h2>

            <div class="margin-top-l">
                Você gostaria de não receber mais e-mails / Whatsapp?
            </div>

            <div class="buttons flex between middle">
                <a @click="sendRemovedContact()" class="button primary">Remover meu Contato</a>
            </div>
        </section>
    </div>
</template>

<script>

import { removedContact } from "@/services/removedContact";


export default {
    name: 'RemovedContact',
    props: ['accId', 'hash'],
    data() {
        return {}
    },
    methods: {
        sendRemovedContact() {
            if (!this.accId || !this.hash) {
                return this.$toast.error({
                    title: "Erro",
                    message: "Link invalido"
                    });
            }

            let haveConf = confirm('Você realmente tem certeza disso?')

            if (!haveConf) {
                return
            }

            removedContact(this.accId, this.hash)
                .then(() => {
                    this.$toast.success({
                        title: "Sucesso",
                        message: "Seu e-mail foi removido com sucesso"
                    });
                })
                .catch(error => {
                    if (error && error.message === "request-canceled") {
                        return;
                    }

                    return this.$toast.error({
                        title: "Erro",
                        message: "Ocorreu um erro interno na sua solicitação"
                    });
                });
            }
    }
}
</script>
